import { createContext, useContext } from 'react';

// Set by SettingsMain when the viewer may not change anything (vendor
// logins). SettingCard and the few inline control buttons read it so every
// editor in the settings tree goes quiet without threading a prop through
// each category component.
export const SettingsReadOnlyContext = createContext(false);

export const useSettingsReadOnly = () => useContext(SettingsReadOnlyContext);
